module.exports = __webpack_public_path__ + "img/kl_msg.0a768b44.png";